export default "__VITE_PUBLIC_ASSET__a49c5444__"